export const LOCAL_STORAGE_KEYS = {
    /// Used to indicate that the application fee bank setup full-screen modal should open immediately 
    /// upon opening the application fee settings page.
    OpenFeeBankAccountSetupOnSettings: 'OpenFeeBankAccountSetupOnSettings',
};
